import { render } from "./OrderStatus.vue?vue&type=template&id=a35846f2"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"

import "./OrderStatus.vue?vue&type=style&index=0&id=a35846f2&lang=css"
script.render = render

export default script